document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.custom-bundle-option');
    if (!buttons.length) return;

    const sectionId = buttons[0].dataset.section;
    const variantSelect = document.getElementById('variant-selects-' + sectionId);
    const fieldsets = variantSelect?.querySelectorAll('fieldset');

    function applyVariantSelection(optionVariants) {
        if (!optionVariants.length) return;

        fieldsets.forEach((select, index) => {
        const optionValue = optionVariants[index];
        if (!optionValue) return;

        const optionToSelect = Array.from(select.querySelectorAll('input[type="radio"]')).find(
            (input) => input.value == optionValue
        );

        if (optionToSelect) {
            optionToSelect.checked = true;
        }
        });

        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function activateButton(btn) {
        buttons.forEach((b) => b.classList.remove('active'));
        btn.classList.add('active');
    }

    buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
        console.log('btn.dataset.variantOptions ', btn.dataset.variantOptions);
        const optionVariants = btn.dataset.variantOptions.split(';');
        const variantId = btn.dataset.variantId;
        activateButton(btn);
        applyVariantSelection(optionVariants);
        });
    });

    // Sélection automatique de la première option au chargement
    const first = buttons[0];
    if (first) {
        first.classList.add('active');
        const optionVariants = first.dataset.variantOptions.split(';');
        applyVariantSelection(optionVariants);
    }
    });